export const SOCIALS = [
  { id: "linkedin", label: "LinkedIn", href: "https://www.linkedin.com/in/youngjiadihe/" },
  { id: "behance", label: "Behance", href: "https://www.behance.net/younghe1" },
  { id: "github", label: "GitHub", href: "https://github.com/youngrighthere" },
  { id: "medium", label: "Medium", href: "https://medium.com/@jiadiyounghe" },
];
